import RemitsList from "../components/RemitsList/RemitsList";

export default function BatchRemits() {
    return <RemitsList />;
}
